import { GetImage } from '@front-app/util/image';
import { getImage, ImageResult, ImageUrl } from '@front-app/services/ImageApi/ImageApi';
import { ImageParams } from '@front-app/services/ImageApi/ImageModel';
import {
	getEventLogo,
	getEventBanner,
	getEventVenue,
	getPublicEventBanner,
} from '@front-app/services/EventsApi/EventsApi';
import { getGroupBanner, getGroupLogo } from '@front-app/services/GroupsApi/GroupsApi';
import { getUserAvatar } from '@front-app/services/UserApi/UserApi';

export interface ImageFetcher {
	fetchV1Image(params: ImageParams, headers: Record<string, string>): Promise<ImageUrl>;
	getEventLogo: GetImage;
	getEventBanner: GetImage;
	getEventVenue: GetImage;
	getGroupLogo: GetImage;
	getGroupBanner: GetImage;
	getPublicEventBanner: GetImage;
	getUserAvatar: GetImage;
}

export const imageFetcher = {
	async fetchV1Image(params: ImageParams, headers: Record<string, string>): Promise<ImageUrl> {
		return getImage(params, headers)
			.then(getDataString);
	},
	getEventLogo,
	getEventBanner,
	getEventVenue,
	getGroupLogo,
	getGroupBanner,
	getPublicEventBanner,
	getUserAvatar,
};

function getDataString({ mimeType, encodedFile }: ImageResult): ImageUrl {
	return `data:${mimeType};base64,${encodedFile}` as ImageUrl;
}
